import React, { useEffect } from "react"

import Button from "@fuse/sharedComponents/buttons/SolidBtn"
import LoadingSpinner from "@fuse/sharedComponents/loader/LoadingSpinner"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { TWebUser } from "@letshang/constants"
import { size } from "lodash-es"
import { useRecoilState } from "recoil"

import { screenState, userState } from "@fuse/recoil/signup"

import { useSignup } from "@fuse/pages/signUp/controller"

const Name = () => {
  const [, setStep] = useRecoilState(screenState)

  const [user, setUser] = useRecoilState(userState)
  const { isLoading } = useSignup()

  const [isErrorModalOpen, setIsErrorModalOpen] = React.useState(false)

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUser((prev: TWebUser) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSubmit = () => {
    if (user?.name?.length < 3) {
      setIsErrorModalOpen(true)
    } else {
      setStep(4)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
      <div className="w-[90%] max-w-sm mb-5 md:mb-10 text-start">
        <p className="text-white/30 text-left text-sm mt-10 md:mt-0 lg:mt-0 font-medium">
          STEP 2
        </p>
        <FancyText className="text-xl md:text-2.5xl mt-[10px] text-white font-semibold">
          Setting up your profile
        </FancyText>
      </div>
      <div className="relative z-[10]">{isLoading && <LoadingSpinner />}</div>
      <div className="w-[90%] max-w-sm bg-white/10 relative rounded-2xl p-10 space-y-6">
        {/* Title */}
        <div className="text-left">
          <h2 className="text-white text-2xl font-semibold">
            Welcome to{" "}
            <span className="bg-gradient-to-r from-[#C190FF]  to-[#A9A4FF] inline-block text-transparent bg-clip-text">
              Let’s Hang!
            </span>
          </h2>

          <p className="text-white/35 mt-2">What do your friends call you?</p>
        </div>

        <div className="flex items-center gap-2 pb-24">
          <div className="px-4 bg-white/20 h-12 rounded-md flex w-full items-center">
            <input
              type="text"
              placeholder={"Your full name"}
              className="w-full h-full bg-transparent text-white text-[16px] placeholder-white/35 outline-none px-2"
              autoFocus
              name="name"
              value={user.name}
              onChange={(e) => handleOnChange(e)}
            />
          </div>
        </div>

        {/* <Button
          className="w-full bg-white/20 text-white py-3 rounded-full font-medium transition"
          disabled={size(user?.name) < 3}
          onClick={() => {
            handleSubmit()
          }}
        >
          Continue
        </Button> */}

        <button
          className={`w-full bg-white/20 text-white py-3 rounded-full font-medium transition ${!(size(user?.name) < 3) ? "" : "opacity-50"}`}
          onClick={() => {
            handleSubmit()
          }}
          disabled={size(user?.name) < 3}
        >
          Continue
        </button>
      </div>
    </div>
  )
}

export default Name
